module.exports = {
	"getNotified": "Soyez informé",
	"launchingSoon": "Soyez prêt, notre lancement arrive bientôt!",
	"slogan": "Rallier les gens à vivre des enchères à travers le monde.",
	"success": "Vous serez informé au sujet de notre lancement! À bientôt!",
	"wedo": " Nous construisons et permettons des solutions avancées pour les encanteurs et les vendeurs.",
	"errors": {
		"alreadySubscribed": "Vous êtes déjà abonné!"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/comingSoon.json5
// module id = 1975
// module chunks = 6